import { render, staticRenderFns } from "./CalidadSection.vue?vue&type=template&id=4998c04e&scoped=true&"
import script from "./CalidadSection.vue?vue&type=script&lang=js&"
export * from "./CalidadSection.vue?vue&type=script&lang=js&"
import style0 from "./CalidadSection.vue?vue&type=style&index=0&id=4998c04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998c04e",
  null
  
)

export default component.exports